import React from 'react';

const Modal = ({ show, onClose, title, children, footer, size }) => {
  if (!show) return null;

  return (
    <div className="modal show d-block custom-modal-backdrop" tabIndex="-1" onClick={onClose}>
      <div className={`modal-dialog modal-dialog-centered modal-animate-in ${size || ''}`} onClick={(e) => e.stopPropagation()}>
        <div className="modal-content modal-modern border-0 shadow-lg overflow-hidden">
          <div className="modal-header border-0 p-4 pb-0 align-items-center">
            <h5 className="modal-title fw-bold">{title}</h5>
            <button type="button" className="btn-close-custom" onClick={onClose}>
              <i className="bi bi-x-lg"></i>
            </button>
          </div>
          <div className="modal-body p-4 pt-3">
            {children}
          </div>
          {footer && (
            <div className="modal-footer border-0 px-4 pb-4 pt-0">
              {footer}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Modal;
